import angular from 'angular';
import LicenseRenewalWidgetComponent from './license-renewal-widget-component';

export default angular.module('license-renewal-widget', []).component('licenseRenewalWidget', new LicenseRenewalWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/license-renewal-widget-module.js